import { useMemo, useState } from 'react';

import {
  TestCycleSortFunctions,
  TestCycleSortStrategy,
} from './TestCycleSorter.util';

export default function useTestCycleSorter() {
  const [testCycleSortStrategy, setTestCycleSortStrategy] =
    useState<TestCycleSortStrategy>('none');

  const { testCycleSortFunction, isTestCycleSorted } = useMemo(() => {
    return {
      testCycleSortFunction: TestCycleSortFunctions[testCycleSortStrategy],
      isTestCycleSorted: testCycleSortStrategy !== 'none',
    };
  }, [testCycleSortStrategy]);

  const setTestCycleSortStrategyWrapper = (value: TestCycleSortStrategy) => {
    // Wrapper on state setter to simplify propagated type
    setTestCycleSortStrategy(value);
  };

  return {
    testCycleSortStrategy,
    setTestCycleSortStrategy: setTestCycleSortStrategyWrapper,
    testCycleSortFunction,
    isTestCycleSorted,
  };
}
